// source: fitness-service/v1/exercise.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.fitness.service.v1.CreateExerciseRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.CreateExerciseResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.DeleteExerciseRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.DeleteExerciseResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.Exercise', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetExerciseRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetExerciseResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetExercisesRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetExercisesResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.UpdateExerciseRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.UpdateExerciseResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.Exercise = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.Exercise, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.Exercise.displayName = 'proto.fitness.service.v1.Exercise';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.CreateExerciseRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.CreateExerciseRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.CreateExerciseRequest.displayName = 'proto.fitness.service.v1.CreateExerciseRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.CreateExerciseResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.CreateExerciseResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.CreateExerciseResponse.displayName = 'proto.fitness.service.v1.CreateExerciseResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetExercisesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetExercisesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetExercisesRequest.displayName = 'proto.fitness.service.v1.GetExercisesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetExercisesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.GetExercisesResponse.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.GetExercisesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetExercisesResponse.displayName = 'proto.fitness.service.v1.GetExercisesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetExerciseRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetExerciseRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetExerciseRequest.displayName = 'proto.fitness.service.v1.GetExerciseRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetExerciseResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetExerciseResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetExerciseResponse.displayName = 'proto.fitness.service.v1.GetExerciseResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.UpdateExerciseRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.UpdateExerciseRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.UpdateExerciseRequest.displayName = 'proto.fitness.service.v1.UpdateExerciseRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.UpdateExerciseResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.UpdateExerciseResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.UpdateExerciseResponse.displayName = 'proto.fitness.service.v1.UpdateExerciseResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.DeleteExerciseRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.DeleteExerciseRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.DeleteExerciseRequest.displayName = 'proto.fitness.service.v1.DeleteExerciseRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.DeleteExerciseResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.DeleteExerciseResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.DeleteExerciseResponse.displayName = 'proto.fitness.service.v1.DeleteExerciseResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.Exercise.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.Exercise.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.Exercise} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.Exercise.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
category: jspb.Message.getFieldWithDefault(msg, 4, ""),
muscleGroup: jspb.Message.getFieldWithDefault(msg, 5, ""),
equipment: jspb.Message.getFieldWithDefault(msg, 6, ""),
instructions: jspb.Message.getFieldWithDefault(msg, 7, ""),
imageUrl: jspb.Message.getFieldWithDefault(msg, 8, ""),
createdBy: jspb.Message.getFieldWithDefault(msg, 9, ""),
isPublic: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.Exercise}
 */
proto.fitness.service.v1.Exercise.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.Exercise;
  return proto.fitness.service.v1.Exercise.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.Exercise} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.Exercise}
 */
proto.fitness.service.v1.Exercise.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCategory(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMuscleGroup(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setEquipment(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setInstructions(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setImageUrl(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCreatedBy(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPublic(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.Exercise.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.Exercise.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.Exercise} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.Exercise.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMuscleGroup();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEquipment();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getInstructions();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getImageUrl();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCreatedBy();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getIsPublic();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.fitness.service.v1.Exercise.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.Exercise} returns this
 */
proto.fitness.service.v1.Exercise.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.fitness.service.v1.Exercise.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.Exercise} returns this
 */
proto.fitness.service.v1.Exercise.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.fitness.service.v1.Exercise.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.Exercise} returns this
 */
proto.fitness.service.v1.Exercise.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string category = 4;
 * @return {string}
 */
proto.fitness.service.v1.Exercise.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.Exercise} returns this
 */
proto.fitness.service.v1.Exercise.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string muscle_group = 5;
 * @return {string}
 */
proto.fitness.service.v1.Exercise.prototype.getMuscleGroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.Exercise} returns this
 */
proto.fitness.service.v1.Exercise.prototype.setMuscleGroup = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string equipment = 6;
 * @return {string}
 */
proto.fitness.service.v1.Exercise.prototype.getEquipment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.Exercise} returns this
 */
proto.fitness.service.v1.Exercise.prototype.setEquipment = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string instructions = 7;
 * @return {string}
 */
proto.fitness.service.v1.Exercise.prototype.getInstructions = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.Exercise} returns this
 */
proto.fitness.service.v1.Exercise.prototype.setInstructions = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string image_url = 8;
 * @return {string}
 */
proto.fitness.service.v1.Exercise.prototype.getImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.Exercise} returns this
 */
proto.fitness.service.v1.Exercise.prototype.setImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string created_by = 9;
 * @return {string}
 */
proto.fitness.service.v1.Exercise.prototype.getCreatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.Exercise} returns this
 */
proto.fitness.service.v1.Exercise.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional bool is_public = 10;
 * @return {boolean}
 */
proto.fitness.service.v1.Exercise.prototype.getIsPublic = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.Exercise} returns this
 */
proto.fitness.service.v1.Exercise.prototype.setIsPublic = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.Exercise.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.Exercise} returns this
*/
proto.fitness.service.v1.Exercise.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.Exercise} returns this
 */
proto.fitness.service.v1.Exercise.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.Exercise.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.Exercise.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.Exercise} returns this
*/
proto.fitness.service.v1.Exercise.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.Exercise} returns this
 */
proto.fitness.service.v1.Exercise.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.Exercise.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 12) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.CreateExerciseRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.CreateExerciseRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.CreateExerciseRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CreateExerciseRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
description: jspb.Message.getFieldWithDefault(msg, 2, ""),
category: jspb.Message.getFieldWithDefault(msg, 3, ""),
muscleGroup: jspb.Message.getFieldWithDefault(msg, 4, ""),
equipment: jspb.Message.getFieldWithDefault(msg, 5, ""),
instructions: jspb.Message.getFieldWithDefault(msg, 6, ""),
imageUrl: jspb.Message.getFieldWithDefault(msg, 7, ""),
isPublic: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.CreateExerciseRequest}
 */
proto.fitness.service.v1.CreateExerciseRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.CreateExerciseRequest;
  return proto.fitness.service.v1.CreateExerciseRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.CreateExerciseRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.CreateExerciseRequest}
 */
proto.fitness.service.v1.CreateExerciseRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCategory(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMuscleGroup(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setEquipment(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setInstructions(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setImageUrl(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPublic(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.CreateExerciseRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.CreateExerciseRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.CreateExerciseRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CreateExerciseRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMuscleGroup();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEquipment();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getInstructions();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getImageUrl();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIsPublic();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.fitness.service.v1.CreateExerciseRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateExerciseRequest} returns this
 */
proto.fitness.service.v1.CreateExerciseRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.fitness.service.v1.CreateExerciseRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateExerciseRequest} returns this
 */
proto.fitness.service.v1.CreateExerciseRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string category = 3;
 * @return {string}
 */
proto.fitness.service.v1.CreateExerciseRequest.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateExerciseRequest} returns this
 */
proto.fitness.service.v1.CreateExerciseRequest.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string muscle_group = 4;
 * @return {string}
 */
proto.fitness.service.v1.CreateExerciseRequest.prototype.getMuscleGroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateExerciseRequest} returns this
 */
proto.fitness.service.v1.CreateExerciseRequest.prototype.setMuscleGroup = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string equipment = 5;
 * @return {string}
 */
proto.fitness.service.v1.CreateExerciseRequest.prototype.getEquipment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateExerciseRequest} returns this
 */
proto.fitness.service.v1.CreateExerciseRequest.prototype.setEquipment = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string instructions = 6;
 * @return {string}
 */
proto.fitness.service.v1.CreateExerciseRequest.prototype.getInstructions = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateExerciseRequest} returns this
 */
proto.fitness.service.v1.CreateExerciseRequest.prototype.setInstructions = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string image_url = 7;
 * @return {string}
 */
proto.fitness.service.v1.CreateExerciseRequest.prototype.getImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateExerciseRequest} returns this
 */
proto.fitness.service.v1.CreateExerciseRequest.prototype.setImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool is_public = 8;
 * @return {boolean}
 */
proto.fitness.service.v1.CreateExerciseRequest.prototype.getIsPublic = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.CreateExerciseRequest} returns this
 */
proto.fitness.service.v1.CreateExerciseRequest.prototype.setIsPublic = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.CreateExerciseResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.CreateExerciseResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.CreateExerciseResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CreateExerciseResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
message: jspb.Message.getFieldWithDefault(msg, 1, ""),
exercise: (f = msg.getExercise()) && proto.fitness.service.v1.Exercise.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.CreateExerciseResponse}
 */
proto.fitness.service.v1.CreateExerciseResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.CreateExerciseResponse;
  return proto.fitness.service.v1.CreateExerciseResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.CreateExerciseResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.CreateExerciseResponse}
 */
proto.fitness.service.v1.CreateExerciseResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 2:
      var value = new proto.fitness.service.v1.Exercise;
      reader.readMessage(value,proto.fitness.service.v1.Exercise.deserializeBinaryFromReader);
      msg.setExercise(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.CreateExerciseResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.CreateExerciseResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.CreateExerciseResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CreateExerciseResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExercise();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.fitness.service.v1.Exercise.serializeBinaryToWriter
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.fitness.service.v1.CreateExerciseResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateExerciseResponse} returns this
 */
proto.fitness.service.v1.CreateExerciseResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Exercise exercise = 2;
 * @return {?proto.fitness.service.v1.Exercise}
 */
proto.fitness.service.v1.CreateExerciseResponse.prototype.getExercise = function() {
  return /** @type{?proto.fitness.service.v1.Exercise} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.Exercise, 2));
};


/**
 * @param {?proto.fitness.service.v1.Exercise|undefined} value
 * @return {!proto.fitness.service.v1.CreateExerciseResponse} returns this
*/
proto.fitness.service.v1.CreateExerciseResponse.prototype.setExercise = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.CreateExerciseResponse} returns this
 */
proto.fitness.service.v1.CreateExerciseResponse.prototype.clearExercise = function() {
  return this.setExercise(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.CreateExerciseResponse.prototype.hasExercise = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetExercisesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetExercisesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetExercisesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetExercisesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
page: jspb.Message.getFieldWithDefault(msg, 1, 0),
limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
category: jspb.Message.getFieldWithDefault(msg, 3, ""),
muscleGroup: jspb.Message.getFieldWithDefault(msg, 4, ""),
equipment: jspb.Message.getFieldWithDefault(msg, 5, ""),
publicOnly: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
search: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetExercisesRequest}
 */
proto.fitness.service.v1.GetExercisesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetExercisesRequest;
  return proto.fitness.service.v1.GetExercisesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetExercisesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetExercisesRequest}
 */
proto.fitness.service.v1.GetExercisesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCategory(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMuscleGroup(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setEquipment(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPublicOnly(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSearch(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetExercisesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetExercisesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetExercisesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetExercisesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMuscleGroup();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEquipment();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPublicOnly();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getSearch();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional int32 page = 1;
 * @return {number}
 */
proto.fitness.service.v1.GetExercisesRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetExercisesRequest} returns this
 */
proto.fitness.service.v1.GetExercisesRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.fitness.service.v1.GetExercisesRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetExercisesRequest} returns this
 */
proto.fitness.service.v1.GetExercisesRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string category = 3;
 * @return {string}
 */
proto.fitness.service.v1.GetExercisesRequest.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetExercisesRequest} returns this
 */
proto.fitness.service.v1.GetExercisesRequest.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string muscle_group = 4;
 * @return {string}
 */
proto.fitness.service.v1.GetExercisesRequest.prototype.getMuscleGroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetExercisesRequest} returns this
 */
proto.fitness.service.v1.GetExercisesRequest.prototype.setMuscleGroup = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string equipment = 5;
 * @return {string}
 */
proto.fitness.service.v1.GetExercisesRequest.prototype.getEquipment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetExercisesRequest} returns this
 */
proto.fitness.service.v1.GetExercisesRequest.prototype.setEquipment = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool public_only = 6;
 * @return {boolean}
 */
proto.fitness.service.v1.GetExercisesRequest.prototype.getPublicOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.GetExercisesRequest} returns this
 */
proto.fitness.service.v1.GetExercisesRequest.prototype.setPublicOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string search = 7;
 * @return {string}
 */
proto.fitness.service.v1.GetExercisesRequest.prototype.getSearch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetExercisesRequest} returns this
 */
proto.fitness.service.v1.GetExercisesRequest.prototype.setSearch = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.GetExercisesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetExercisesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetExercisesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetExercisesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetExercisesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
exercisesList: jspb.Message.toObjectList(msg.getExercisesList(),
    proto.fitness.service.v1.Exercise.toObject, includeInstance),
totalCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
page: jspb.Message.getFieldWithDefault(msg, 3, 0),
limit: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetExercisesResponse}
 */
proto.fitness.service.v1.GetExercisesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetExercisesResponse;
  return proto.fitness.service.v1.GetExercisesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetExercisesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetExercisesResponse}
 */
proto.fitness.service.v1.GetExercisesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.Exercise;
      reader.readMessage(value,proto.fitness.service.v1.Exercise.deserializeBinaryFromReader);
      msg.addExercises(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetExercisesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetExercisesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetExercisesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetExercisesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExercisesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fitness.service.v1.Exercise.serializeBinaryToWriter
    );
  }
  f = message.getTotalCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * repeated Exercise exercises = 1;
 * @return {!Array<!proto.fitness.service.v1.Exercise>}
 */
proto.fitness.service.v1.GetExercisesResponse.prototype.getExercisesList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.Exercise>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.Exercise, 1));
};


/**
 * @param {!Array<!proto.fitness.service.v1.Exercise>} value
 * @return {!proto.fitness.service.v1.GetExercisesResponse} returns this
*/
proto.fitness.service.v1.GetExercisesResponse.prototype.setExercisesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fitness.service.v1.Exercise=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.Exercise}
 */
proto.fitness.service.v1.GetExercisesResponse.prototype.addExercises = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fitness.service.v1.Exercise, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.GetExercisesResponse} returns this
 */
proto.fitness.service.v1.GetExercisesResponse.prototype.clearExercisesList = function() {
  return this.setExercisesList([]);
};


/**
 * optional int32 total_count = 2;
 * @return {number}
 */
proto.fitness.service.v1.GetExercisesResponse.prototype.getTotalCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetExercisesResponse} returns this
 */
proto.fitness.service.v1.GetExercisesResponse.prototype.setTotalCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page = 3;
 * @return {number}
 */
proto.fitness.service.v1.GetExercisesResponse.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetExercisesResponse} returns this
 */
proto.fitness.service.v1.GetExercisesResponse.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 limit = 4;
 * @return {number}
 */
proto.fitness.service.v1.GetExercisesResponse.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetExercisesResponse} returns this
 */
proto.fitness.service.v1.GetExercisesResponse.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetExerciseRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetExerciseRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetExerciseRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetExerciseRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
exerciseId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetExerciseRequest}
 */
proto.fitness.service.v1.GetExerciseRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetExerciseRequest;
  return proto.fitness.service.v1.GetExerciseRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetExerciseRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetExerciseRequest}
 */
proto.fitness.service.v1.GetExerciseRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setExerciseId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetExerciseRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetExerciseRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetExerciseRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetExerciseRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExerciseId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string exercise_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.GetExerciseRequest.prototype.getExerciseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetExerciseRequest} returns this
 */
proto.fitness.service.v1.GetExerciseRequest.prototype.setExerciseId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetExerciseResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetExerciseResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetExerciseResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetExerciseResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
exercise: (f = msg.getExercise()) && proto.fitness.service.v1.Exercise.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetExerciseResponse}
 */
proto.fitness.service.v1.GetExerciseResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetExerciseResponse;
  return proto.fitness.service.v1.GetExerciseResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetExerciseResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetExerciseResponse}
 */
proto.fitness.service.v1.GetExerciseResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.Exercise;
      reader.readMessage(value,proto.fitness.service.v1.Exercise.deserializeBinaryFromReader);
      msg.setExercise(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetExerciseResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetExerciseResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetExerciseResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetExerciseResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExercise();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fitness.service.v1.Exercise.serializeBinaryToWriter
    );
  }
};


/**
 * optional Exercise exercise = 1;
 * @return {?proto.fitness.service.v1.Exercise}
 */
proto.fitness.service.v1.GetExerciseResponse.prototype.getExercise = function() {
  return /** @type{?proto.fitness.service.v1.Exercise} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.Exercise, 1));
};


/**
 * @param {?proto.fitness.service.v1.Exercise|undefined} value
 * @return {!proto.fitness.service.v1.GetExerciseResponse} returns this
*/
proto.fitness.service.v1.GetExerciseResponse.prototype.setExercise = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.GetExerciseResponse} returns this
 */
proto.fitness.service.v1.GetExerciseResponse.prototype.clearExercise = function() {
  return this.setExercise(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.GetExerciseResponse.prototype.hasExercise = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.UpdateExerciseRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.UpdateExerciseRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.UpdateExerciseRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateExerciseRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
exerciseId: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
category: jspb.Message.getFieldWithDefault(msg, 4, ""),
muscleGroup: jspb.Message.getFieldWithDefault(msg, 5, ""),
equipment: jspb.Message.getFieldWithDefault(msg, 6, ""),
instructions: jspb.Message.getFieldWithDefault(msg, 7, ""),
imageUrl: jspb.Message.getFieldWithDefault(msg, 8, ""),
isPublic: jspb.Message.getBooleanFieldWithDefault(msg, 9, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.UpdateExerciseRequest}
 */
proto.fitness.service.v1.UpdateExerciseRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.UpdateExerciseRequest;
  return proto.fitness.service.v1.UpdateExerciseRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.UpdateExerciseRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.UpdateExerciseRequest}
 */
proto.fitness.service.v1.UpdateExerciseRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setExerciseId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCategory(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMuscleGroup(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setEquipment(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setInstructions(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setImageUrl(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPublic(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.UpdateExerciseRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.UpdateExerciseRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.UpdateExerciseRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateExerciseRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExerciseId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMuscleGroup();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEquipment();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getInstructions();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getImageUrl();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getIsPublic();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
};


/**
 * optional string exercise_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.UpdateExerciseRequest.prototype.getExerciseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateExerciseRequest} returns this
 */
proto.fitness.service.v1.UpdateExerciseRequest.prototype.setExerciseId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.fitness.service.v1.UpdateExerciseRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateExerciseRequest} returns this
 */
proto.fitness.service.v1.UpdateExerciseRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.fitness.service.v1.UpdateExerciseRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateExerciseRequest} returns this
 */
proto.fitness.service.v1.UpdateExerciseRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string category = 4;
 * @return {string}
 */
proto.fitness.service.v1.UpdateExerciseRequest.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateExerciseRequest} returns this
 */
proto.fitness.service.v1.UpdateExerciseRequest.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string muscle_group = 5;
 * @return {string}
 */
proto.fitness.service.v1.UpdateExerciseRequest.prototype.getMuscleGroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateExerciseRequest} returns this
 */
proto.fitness.service.v1.UpdateExerciseRequest.prototype.setMuscleGroup = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string equipment = 6;
 * @return {string}
 */
proto.fitness.service.v1.UpdateExerciseRequest.prototype.getEquipment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateExerciseRequest} returns this
 */
proto.fitness.service.v1.UpdateExerciseRequest.prototype.setEquipment = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string instructions = 7;
 * @return {string}
 */
proto.fitness.service.v1.UpdateExerciseRequest.prototype.getInstructions = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateExerciseRequest} returns this
 */
proto.fitness.service.v1.UpdateExerciseRequest.prototype.setInstructions = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string image_url = 8;
 * @return {string}
 */
proto.fitness.service.v1.UpdateExerciseRequest.prototype.getImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateExerciseRequest} returns this
 */
proto.fitness.service.v1.UpdateExerciseRequest.prototype.setImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional bool is_public = 9;
 * @return {boolean}
 */
proto.fitness.service.v1.UpdateExerciseRequest.prototype.getIsPublic = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.UpdateExerciseRequest} returns this
 */
proto.fitness.service.v1.UpdateExerciseRequest.prototype.setIsPublic = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.UpdateExerciseResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.UpdateExerciseResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.UpdateExerciseResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateExerciseResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
message: jspb.Message.getFieldWithDefault(msg, 1, ""),
exercise: (f = msg.getExercise()) && proto.fitness.service.v1.Exercise.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.UpdateExerciseResponse}
 */
proto.fitness.service.v1.UpdateExerciseResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.UpdateExerciseResponse;
  return proto.fitness.service.v1.UpdateExerciseResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.UpdateExerciseResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.UpdateExerciseResponse}
 */
proto.fitness.service.v1.UpdateExerciseResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 2:
      var value = new proto.fitness.service.v1.Exercise;
      reader.readMessage(value,proto.fitness.service.v1.Exercise.deserializeBinaryFromReader);
      msg.setExercise(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.UpdateExerciseResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.UpdateExerciseResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.UpdateExerciseResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateExerciseResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExercise();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.fitness.service.v1.Exercise.serializeBinaryToWriter
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.fitness.service.v1.UpdateExerciseResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateExerciseResponse} returns this
 */
proto.fitness.service.v1.UpdateExerciseResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Exercise exercise = 2;
 * @return {?proto.fitness.service.v1.Exercise}
 */
proto.fitness.service.v1.UpdateExerciseResponse.prototype.getExercise = function() {
  return /** @type{?proto.fitness.service.v1.Exercise} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.Exercise, 2));
};


/**
 * @param {?proto.fitness.service.v1.Exercise|undefined} value
 * @return {!proto.fitness.service.v1.UpdateExerciseResponse} returns this
*/
proto.fitness.service.v1.UpdateExerciseResponse.prototype.setExercise = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.UpdateExerciseResponse} returns this
 */
proto.fitness.service.v1.UpdateExerciseResponse.prototype.clearExercise = function() {
  return this.setExercise(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.UpdateExerciseResponse.prototype.hasExercise = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.DeleteExerciseRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.DeleteExerciseRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.DeleteExerciseRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DeleteExerciseRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
exerciseId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.DeleteExerciseRequest}
 */
proto.fitness.service.v1.DeleteExerciseRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.DeleteExerciseRequest;
  return proto.fitness.service.v1.DeleteExerciseRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.DeleteExerciseRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.DeleteExerciseRequest}
 */
proto.fitness.service.v1.DeleteExerciseRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setExerciseId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.DeleteExerciseRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.DeleteExerciseRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.DeleteExerciseRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DeleteExerciseRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExerciseId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string exercise_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.DeleteExerciseRequest.prototype.getExerciseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.DeleteExerciseRequest} returns this
 */
proto.fitness.service.v1.DeleteExerciseRequest.prototype.setExerciseId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.DeleteExerciseResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.DeleteExerciseResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.DeleteExerciseResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DeleteExerciseResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
message: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.DeleteExerciseResponse}
 */
proto.fitness.service.v1.DeleteExerciseResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.DeleteExerciseResponse;
  return proto.fitness.service.v1.DeleteExerciseResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.DeleteExerciseResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.DeleteExerciseResponse}
 */
proto.fitness.service.v1.DeleteExerciseResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.DeleteExerciseResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.DeleteExerciseResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.DeleteExerciseResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DeleteExerciseResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.fitness.service.v1.DeleteExerciseResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.DeleteExerciseResponse} returns this
 */
proto.fitness.service.v1.DeleteExerciseResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.fitness.service.v1);
